export class AccountDropdownLink {
    labelTranslationKey : string; // 'navigation.connections'
    routerLinkArray : string[]; // ['/hubs']
    iconClasses : string; // 'fa-solid fa-star'
    filteredRoles : string[]; // ['Interculturalist','Admin']
    clickHandler : string; // 'doLogout' name of the function as a string
    isDivider? : boolean;
    isHeader? : boolean;
  }